export default __webpack_public_path__ + "static/media/weightlossregime_1@2x.f3ed28c1.jpg";